<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onupload="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_label_Remark_project_name_search') || '文档说明/项目名称 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>

                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="600px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form
        ref="form"
        :model="form"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_document_type') || '文档类型'"
              prop="prjFileType"
            >
              <dict-select
                size="small"
                clearable
                filterable
                v-model="form.prjFileType"
                :body="prjFileTypeParams"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                url="/sys/common/dict/system"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$l('form_doc_remark') || '文档说明'">
              <el-input
                v-model.trim="form.prjFileDesc"
                :placeholder="
                  $l('form_please_input_doc_remark') || '请输入文档说明'
                "
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$l('form_title_uploadByName') || '上传人'">
              <dict-select
                v-model="form.uploadPersonCode"
                url="/digitalCenter/common/dict/baseUser"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                style="width: 100%"
                filterable
                :multiple="false"
                clearable
                :options="{ label: 'label', value: 'code' }"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item :label="$l('form_label_upload_time') || '上传时间'">
            <el-col :span="24">
              <el-col :span="11">
                <el-date-picker
                  v-model="form.uploadTimeStart"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  :picker-options="uploadTimeStartPicker"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                ></el-date-picker>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-date-picker
                  v-model="form.uploadTimeEnd"
                  type="date"
                  size="small"
                  value-format="yyyy-MM-dd"
                  :picker-options="uploadTimeEndPicker"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                ></el-date-picker>
              </el-col>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}</el-button
        >
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  prjFileType: '',
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      prjFileTypeParams: { dictType: 'prjFileType' },

      //提交日期限制
      uploadTimeStartPicker: this.uploadTimeEnd(),
      uploadTimeEndPicker: this.uploadTimeStart(),
    }
  },
  created() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    // 提交时间限制
    uploadTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.uploadTimeEnd) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.uploadTimeEnd).getTime() < time.getTime()
          }
        },
      }
    },
    uploadTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.uploadTimeStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.uploadTimeStart).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
